module.exports = __webpack_public_path__ + "img/icon-list1.7954d223.svg";